import color1 from "./1.jpeg";
import color2 from "./2.jpeg";
import color3 from "./3.jpeg";
import color4 from "./4.jpeg";
import color5 from "./5.jpeg";
import color6 from "./6.jpeg";
import color7 from "./7.jpeg";
import color8 from "./8.jpeg";
import color9 from "./9.jpeg";
import color10 from "./10.jpeg";
import color11 from "./11.jpg";
import color12 from "./12.jpg";


export const ColorsCampaign = {
    color1,
    color2,
    color3,
    color4,
    color5,
    color6,
    color7,
    color8,
    color9,
    color10,
    color11,
    color12,
}